import React, { useRef } from 'react';
import { Modal } from '../shared';

const RecruitingCreateModalShell = ({
  open,
  onClose,
  methods,
  activeMethod,
  onMethodChange,
  busy,
  title,
  subtitle,
  icon,
  footerNote,
  footerActions,
  children,
}) => {
  const tabRefs = useRef({});

  const selectMethod = methodId => {
    if (!busy) onMethodChange(methodId);
  };

  const handleKeyDown = event => {
    const currentIndex = methods.findIndex(method => method.id === activeMethod);
    let nextIndex;
    if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = methods.length - 1;
    else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % methods.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + methods.length) % methods.length;
    else return;

    event.preventDefault();
    selectMethod(methods[nextIndex].id);
    tabRefs.current[methods[nextIndex].id]?.focus();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      icon={icon}
      closeDisabled={busy}
      fillViewport
      contentLayout
      mobileFullscreen
      maxWidth="max-w-6xl"
    >
      <div className="flex min-h-0 flex-1 flex-col bg-gray-50 sm:flex-row">
        <div
          role="tablist"
          aria-label="Méthodes de création"
          className="flex shrink-0 gap-2 overflow-x-auto border-b border-gray-200 bg-white p-3 sm:w-64 sm:flex-col sm:overflow-visible sm:border-b-0 sm:border-r sm:p-4"
        >
          {methods.map(({ id, label, description, icon: MethodIcon }) => {
            const selected = activeMethod === id;
            return (
              <button
                key={id}
                ref={element => { tabRefs.current[id] = element; }}
                id={`recruiting-method-${id}`}
                type="button"
                role="tab"
                aria-label={label}
                aria-selected={selected}
                aria-controls={`recruiting-panel-${id}`}
                tabIndex={selected ? 0 : -1}
                disabled={busy}
                onClick={() => selectMethod(id)}
                onKeyDown={handleKeyDown}
                className={`min-h-[68px] min-w-[150px] rounded-lg border p-3 text-left transition-colors focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-1 sm:min-w-0 ${selected ? 'border-blue-500 bg-blue-50 text-blue-800' : 'border-transparent text-gray-700 hover:bg-gray-50'}`}
              >
                <span className="flex items-start gap-3">
                  {MethodIcon && <MethodIcon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />}
                  <span>
                    <strong className="block text-sm">{label}</strong>
                    {description && <span className="mt-1 hidden text-xs font-normal text-gray-500 sm:block">{description}</span>}
                  </span>
                </span>
              </button>
            );
          })}
        </div>
        <div
          id={`recruiting-panel-${activeMethod}`}
          role="tabpanel"
          aria-labelledby={`recruiting-method-${activeMethod}`}
          className="min-h-0 min-w-0 flex-1 overflow-y-auto p-4 sm:p-6"
        >
          <div className="mx-auto max-w-3xl">{children}</div>
        </div>
      </div>
      <footer className="shrink-0 border-t border-gray-200 bg-white px-4 py-3 shadow-sm sm:px-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="hidden text-sm text-gray-500 sm:block">{footerNote}</div>
          <div className="flex w-full flex-col-reverse gap-2 sm:w-auto sm:flex-row sm:items-center [&>button]:min-h-[44px] [&>button:last-child]:w-full sm:[&>button:last-child]:w-auto">
            {footerActions}
          </div>
        </div>
      </footer>
    </Modal>
  );
};

export default RecruitingCreateModalShell;
